import { css } from '@emotion/core';
import { Color } from '../../../styles/Color';
import { theme } from '../../../styles/theme';
import { Css } from '../../../ui';

export const ArrowLinkStyles = css`
	font-size: ${Css.pxToRem(14)};
	font-weight: 500;
	letter-spacing: ${Css.pxToRem(0.84)};
	color: ${Color.PrimaryBlue};

	&:hover {
		svg {
			transform: translateX(${theme.button?.iconSeparator});
		}
	}

	&:after {
		content: none;
	}

	path {
		stroke-width: 1;
	}
`;
